import { Link } from 'react-router-dom';

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#D4AF37]/15 bg-[#080809]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <img
            src="/assets/img/brand_logo.png"
            alt="Jakson Faucets & Accessories"
            className="h-12 w-auto mb-5"
          />
          <p className="font-serif italic text-xl text-zinc-400">Redefining Water.</p>
          <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600 leading-loose">
            15 years of excellence<br />Eco friendly · Made in India
          </p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Explore</p>
          <div className="flex flex-col gap-3">
            {[
              ['Collections', '/collections', 'collections'],
              ['Finish Atelier', '/', 'atelier'],
              ['Craft', '/craft', 'craft'],
              ['Partners', '/partners', 'partners'],
              ['Contact', '/contact', 'contact'],
            ].map(([label, to, id]) => (
              <Link
                key={id}
                to={to}
                state={id === 'atelier' ? { scrollTo: '#configurator' } : undefined}
                data-testid={`footer-link-${id}`}
                className="text-left text-sm text-zinc-400 hover:text-[#F5E6AD] transition-colors w-fit"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Works</p>
          <p className="text-sm text-zinc-400 leading-relaxed">
            Hindustan Meta Works<br />
            G1-793A RIICO Industrial Area,<br />
            Bhiwadi, Rajasthan — 301019
          </p>
          <p className="mt-4 text-sm text-zinc-400">+91 98118 60677</p>
          <p className="text-sm text-zinc-400">works.hindustanmetaworks@gmail.com</p>
        </div>
      </div>
      <div className="mt-14 pt-7 border-t border-zinc-900 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
          © 2026 Jakson Faucets &amp; Accessories. All rights reserved.
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
          Price list effective April 2026 · <a href="/admin" data-testid="footer-admin-link" className="hover:text-[#D4AF37] transition-colors">Admin</a>
        </p>
      </div>
    </div>
  </footer>
);
